import { useLocation, useNavigate } from 'react-router'
import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { getBasePath } from '../../../../../../../utils/globals/link'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'

interface ModalChangeActiveTaskTypeProps extends ModalEditComponentProps { }

const ModalChangeActiveTaskType: React.FC<ModalChangeActiveTaskTypeProps> = ({ setOpened, onSubmit, allRowData }) => {
    if (allRowData?.active === false) {
        return <ModalReactivateTaskType {...{ setOpened, onSubmit, allRowData }} />
    } else {
        return <ModalDeleteTaskType {...{ setOpened, onSubmit, allRowData }} />
    }
}

const ModalReactivateTaskType: React.FC<ModalChangeActiveTaskTypeProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const navigate = useNavigate()
    const location = useLocation()

    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/task/taskType/updateTaskType',
        data: {
            id: allRowData?.id,
            active: true
        }
    })

    const deleteAndNavigate = useCallback(async () => {
        await handleFetchText()
        navigate(getBasePath(location.pathname, 'taskTypes'));
    }, [handleFetchText, navigate, location.pathname])
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={deleteAndNavigate} translations={{
            title: t('sureReactiveThisTaskType', '¿Seguro que quieres reactivar este tipo de tarea?'),
            subtitle: t('onceReactivatedAbleInTaskTypeList', 'Una vez reactivado volverá a aparecer en el listado de tipos de tarea'),
            buttonAccept: t('reactivate', 'Reactivar')
        }} />
    )
}

const ModalDeleteTaskType: React.FC<ModalChangeActiveTaskTypeProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const navigate = useNavigate()
    const location = useLocation()

    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/task/taskType/updateTaskType',
        data: {
            id: allRowData?.id,
            active: false
        }
    })

    const deleteAndNavigate = useCallback(async () => {
        await handleFetchText()
        navigate(getBasePath(location.pathname, 'taskTypes'));
    }, [handleFetchText, navigate, location.pathname])
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={deleteAndNavigate} translations={{
            title: t('sureUnableTaskType', '¿Seguro que quieres desactivar este tipo de tarea?'),
            subtitle: t('onceDeletedCouldBeRecovered', 'Una vez desactivado se podrá reactivar de nuevo'),
            buttonAccept: t('disable', 'Desactivar')
        }} />
    )
}

export default ModalChangeActiveTaskType